import { AsyncState } from 'react-use/lib/useAsync';
import { ResponseErrorPanel } from '@backstage/core-components';
import { Grid, Skeleton } from '@backstage/ui';
import { SonarQubeServiceGroup } from '../../../api/service-groups/types';
import {
  SummaryValue,
  useCatalogUserOptions,
} from '@internal/plugin-shared-react';
import shared from '../../../styles.module.css';
import styles from './SonarQubeServiceGroupPage.module.css';

interface ServiceGroupGeneralInformationProps {
  state: AsyncState<SonarQubeServiceGroup | undefined>;
}

export const ServiceGroupGeneralInformation = ({
  state,
}: ServiceGroupGeneralInformationProps) => {
  const users = useCatalogUserOptions();
  if (state.loading) {
    return (
      <div className={styles.skeletons}>
        <Skeleton width="60%" height={20} />
        <Skeleton width="80%" height={20} />
        <Skeleton width="40%" height={20} />
      </div>
    );
  }
  if (state.error) {
    return <ResponseErrorPanel error={state.error} />;
  }
  const group = state.value;
  if (!group) {
    return <span className={shared.hintText}>Tooling group not found.</span>;
  }
  const userLabel = (entraId: string) =>
    users.value?.find(u => u.entraId === entraId)?.label ?? entraId;
  return (
    <Grid.Root columns="2" gap="6">
      <SummaryValue label="Application name" value={group.applicationName} />
      <SummaryValue label="Application key" value={group.applicationKey} />
      <SummaryValue
        label="Created at"
        value={new Date(group.createdAt).toLocaleString()}
      />
      <SummaryValue label="Created by" value={userLabel(group.createdBy)} />
      <SummaryValue
        label="Updated at"
        value={group.updatedAt ? new Date(group.updatedAt).toLocaleString() : ''}
      />
      <SummaryValue
        label="Updated by"
        value={group.updatedBy ? userLabel(group.updatedBy) : ''}
      />
      <Grid.Item colSpan="2">
        <SummaryValue
          label="Description"
          value={group.applicationDescription}
        />
      </Grid.Item>
    </Grid.Root>
  );
};